/** Default sort for POST /v1/workspace/list */
export const WORKSPACE_LIST_DEFAULT_SORT = {
  order_by: ['created_at'],
  order_direction: ['desc'],
};

/**
 * @param {number} page
 * @param {number} pageSize
 * @param {string} [searchKeyword] — when non-empty, adds `search: { keyword }` for server-side search
 * @returns {{ page: number, page_size: number, order_by: string[], order_direction: string[], search?: { keyword: string } }}
 */
export const buildWorkspaceListBody = (page, pageSize, searchKeyword = '') => {
  const body = {
    page,
    page_size: pageSize,
    ...WORKSPACE_LIST_DEFAULT_SORT,
  };
  const kw = typeof searchKeyword === 'string' ? searchKeyword.trim() : '';
  if (kw) {
    body.search = { keyword: kw };
  }
  return body;
};
